
import { Vue, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import DefaultLayout from '@/components/DefaultLayout.vue';
import { Address, AddressTypes } from '@/store/models/AddressModel';
import { AddressService } from '@/services/address-service';
import RollDirectionAlert from '@/components/RollDirectonAlert.vue';
import AddEditShippingAddress from '@/components/AddEditShippingAddress.vue';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { CopyToClipboard } from '@/helpers/WebHelper';
import { Confirm } from '@/helpers/AuthHelper';
import CrudAddresses from '@/components/CrudAddresses.vue';
@Component({
  components: {
    DefaultLayout,
    CrudAddresses
  }
})
export default class extends Vue {
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  proofCategory = AddressTypes.Proof;
  /* Methods */
  /* Loaders */
  /* Mounted */
  async mounted() {}
  /* Created */
}
